import { koComponent } from "../../../../ko-utils";
import { getServerSideData } from "../../../page";
import ItemBase from "./itemBase";

class Link extends ItemBase {
    constructor(params) {
        super(params, LinkItemOpts);
    }
}

class LinkItemOpts {
    constructor(data) {
        if (!data) data = {};

        this.url = ko.observable(ko.unwrap(data.url)).extend({ trackChange: { name: 'LinkItemOpts.url' } });
        this.blank = ko.observable(ko.unwrap(data.blank)).extend({ trackChange: { name: 'LinkItemOpts.blank' } });
    }
}

export default koComponent('btn-item-link', Link);